
import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

interface ContentCardProps {
  children: ReactNode;
  className?: string;
}

export const ContentCard = ({ children, className }: ContentCardProps) => {
  return (
    <div className={cn(
      "bg-white rounded-2xl p-3 sm:p-4 md:p-6 border border-gray-100/50 transition-all duration-200 hover:shadow-lg",
      className
    )}>
      {children}
    </div>
  );
};
